import { defaultBackgroundCheckConfig } from '@/backend/features/background-check/defaults';
import { BackgroundCheckType } from '@/backend/features/background-check/types';

export function isManualBackgroundCheck(
    backgroundCheckConfigType: BackgroundCheckType | undefined,
    primaryBackgroundCheckType: BackgroundCheckType | undefined,
) {
    const defaultBackgroundCheckConfigType = Object.entries(defaultBackgroundCheckConfig.type).find(([, value]) => value.enabled)?.[0] as
        | BackgroundCheckType
        | undefined;

    if (!backgroundCheckConfigType && !primaryBackgroundCheckType) {
        return defaultBackgroundCheckConfigType === 'manual';
    }

    return backgroundCheckConfigType === 'manual' || (!backgroundCheckConfigType && primaryBackgroundCheckType === 'manual');
}
